import { render, staticRenderFns } from "./EventInsights.vue?vue&type=template&id=1b878df4&scoped=true"
import script from "./EventInsights.vue?vue&type=script&lang=js"
export * from "./EventInsights.vue?vue&type=script&lang=js"
import style0 from "./EventInsights.vue?vue&type=style&index=0&id=1b878df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b878df4",
  null
  
)

export default component.exports